import { IResponse } from '../types';
import axiosInstance from '../axiosInstance';
import { requestResources } from '../requestResources';
import { IVerifyCodePayload } from './types';

const { clientPortalVerification } = requestResources;

export const submitVerification = (payload: IVerifyCodePayload): IResponse<boolean> =>
  axiosInstance.post(`${clientPortalVerification}`, payload);

export const requestTechnicianVerification = (): IResponse<{ code: string }> =>
  axiosInstance.post(`${clientPortalVerification}/verify-technician`, {});

export const requestTechnicianVerificationOnPortalSide = (): IResponse<{ code: string }> =>
  axiosInstance.post(`${clientPortalVerification}/verify-technician-on-portal-side`, {});

export const checkCodeVerifyTechnician = (
  payload: object,
): IResponse<{ code: string; requestId: number }> =>
  axiosInstance.post(`${clientPortalVerification}/check-code-verify-technician`, payload);
